<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>中继号{{ renderTitle() }}管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入隐私号码/名称"
          v-model="searchValue"
          clearable
          style="width: 270px;"
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          @click="doNew"
          class="c-m-l-10"
          v-if="osg.has(`winnerLooks?useType=${useType},add`)"
        >
          新增
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has(`winnerLooks?useType=${useType},export`)"
          @click="
            osg.doExport(
              {
                'regex:title|string#or': searchValue,
                'regex:privateNum|string#or': searchValue,
                'regex:useName|string#or': searchValue,
                'regex:_id|string#or': searchValue,
                'in:useType|array-integer#and': useType + ',0',
                'ne:state|integer#and': '-1',
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'winnerLook',
                title: `中间号管理列表`
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields" :options="options">
            <template slot="orgIds">
              <el-table-column width="240px" label="关联组织">
                <template slot-scope="scope">
                  <el-cascader
                    placeholder=""
                    class="cascaderwinnerlooks"
                    v-model="scope.row.orgIds"
                    :options="treeDataOptions"
                    :props="{
                      value: '_id',
                      label: 'orgName',
                      children: 'orgList',
                      checkStrictly: true
                    }"
                    :show-all-levels="false"
                    props.checkStrictly="true"
                  ></el-cascader>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has(`winnerLooks?useType=${useType},edit`)"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has(`winnerLooks?useType=${useType},remove`) ||
                        osg.has('winnerLooks?type=all,remove')) &&
                        state != 'archived'
                    "
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (osg.has(`winnerLooks?useType=${useType},remove`) ||
                        osg.has('winnerLooks?type=all,remove')) &&
                        state != 'archived'
                    "
                    @click.native="doLeaveUnused(scope.row._id)"
                  >
                    解绑
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="信息" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="160px"
        :area="area"
        @changeForm="osg.changeForm"
      >
        <template slot="orgIds">
          <el-cascader
            placeholder="请选择"
            v-model="formData.exts.orgIds"
            @change="
              getUsers();
              delete formData.useId;
              delete formData.usePhone;
            "
            :options="treeDataOptions"
            :props="{
              value: '_id',
              label: 'orgName',
              children: 'orgList',
              checkStrictly: true,
              expandTrigger: true
            }"
            :show-all-levels="false"
            props.checkStrictly="true"
          ></el-cascader>
        </template>
        <template slot="useId">
          <template v-if="useType == '1'">
            <el-select
              v-model="formData.useId"
              :remote-method="getUsers"
              filterable
              remote
              :disabled="formData.exts.orgIds && !formData.exts.orgIds.length"
              placeholder="请选择，支持搜索"
              @change="useIdChange($event, useType)"
            >
              <el-option
                v-for="(item, i) in options.users"
                :key="i"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>

          <template v-else-if="useType == '5'">
            <el-select
              v-model="formData.useId"
              :remote-method="getPartner"
              filterable
              remote
              :disabled="formData.exts.orgIds && !formData.exts.orgIds.length"
              placeholder="请选择，支持搜索"
              @change="useIdChange($event, useType)"
            >
              <el-option
                v-for="(item, i) in options.partners"
                :key="i"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
        </template>
        <template slot="startAndEndTime">
          <el-date-picker
            v-model="formData.exts.startAndEndTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00']"
          ></el-date-picker>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'winnerLook',
  data() {
    return {
      tenantId: '',
      name: 'winnerLook',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      //全部组织
      treeDataOptions: [],
      // 上传
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      state: '', //已归档 archived
      useType: ''
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.useType = this.$route.query.useType;
    this.doInit();
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;
    this.osg.getFields('winnerLook', () => {
      if (this.useType == '5') {
        this.extFields = this.extFields
          .filter(
            item =>
              item.name != 'orgIds' &&
              item.name != 'orgName' &&
              item.name != 'field1' &&
              item.name != 'field2'
          )
          .sort((q, n) => q.order - n.order);
      }
      this.osg.listRefresh();
      this.osg.getFpi();
      this.getData();
      this.getOrg();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.state = this.osg.param('state');
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        // 'regex:title|string#or': this.searchValue,
        'regex:privateNum|string#or': this.searchValue,
        'regex:useName|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        'in:useType|array-integer#and': this.useType + ',0',
        // 'in:state|array-integer#and': this.state == 'archived' ? -1 : '1',
        'ne:state|integer#and': '-1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/winnerlook/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      if (this.useType == '5') {
        this.getPartner(); //查询伙伴/服务商
      }
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      if (this.useType == '1') {
        this.getUsers(); //查询人员
      } else if (this.useType == '5') {
        this.getPartner(); //查询伙伴/服务商
      }
      this.openDetail = true;
    },
    //查询人员
    getUsers(query) {
      this.osg.ajax(
        'user/query.do',
        {
          'is:state|integer#and': '1',
          'regex:name|string#or': query,
          'regex:phone|string#or': query,
          'regex:orgName|string#or': query,
          orgId: this.formData.exts.orgIds[this.formData.exts.orgIds.length - 1],
          sortField: 'createTime',
          sortOrder: 'asc',
          page: 1,
          rows: 20
        },
        res => {
          this.options.users = res.data;
          window.$this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //查询伙伴/服务商
    getPartner(query) {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          'is:state|integer#and': '1',
          'regex:name|string#or': query || this.formData.useName,
          'regex:phone|string#or': query,
          'regex:orgName|string#or': query,
          sortField: 'createTime',
          sortOrder: 'asc',
          page: 1,
          rows: 20
        },
        res => {
          this.options.partners = res.data;
          window.$this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    useIdChange(id, useType) {
      console.log(id, useType);
      if (useType == '1') {
        this.formData.usePhone = this.options.users.find(item => item._id == id).phone;
      } else if (useType == '5') {
        this.formData.usePhone = this.options.partners.find(item => item._id == id).phone;
      }
      this.$forceUpdate();
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveFormatExtField(this.extFields, params);
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        } else {
          params.province = '';
          params.city = '';
          params.district = '';
        }
        // 赋值orgId
        if (Array.isArray(params.exts.orgIds)) {
          params.orgId = params.exts.orgIds[params.exts.orgIds.length - 1];
        }
        // 赋值useName
        if (params.useId) {
          if (this.useType == '1') {
            params.useName = this.options.users.find(item => item._id == params.useId).name;
          } else if (this.useType == '5') {
            params.useName = this.options.partners.find(item => item._id == params.useId).name;
          }
        }
        //解析起止时间
        if (
          Array.isArray(this.formData.exts.startAndEndTime) &&
          this.formData.exts.startAndEndTime.length
        ) {
          this.formData.startTime = this.formData.exts.startAndEndTime[0];
          this.formData.endTime = this.formData.exts.startAndEndTime[1];
        }
        params.useType = this.useType;
        this.osg.ajax('basic/winnerlook/upsert.do', { data: JSON.stringify(params) }, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //获取组织
    getOrg() {
      return new Promise(resolve => {
        this.osg.ajax('org/query.do', {}, res => {
          if (res.data) {
            let data = [res.data];
            this.treeData = data;
            this.treeDataOptions = this.removeEmpty(
              res.data && res.data.orgList ? res.data.orgList : []
            );
            // this.formData.description = !res.data._id ? "" : res.data._id;
            resolve();
          }
        });
      });
    },
    //删除
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/winnerlook/due.do', { id }, () => {
          this.osg.toast('操作成功');
          this.getData();
        });
      });
    },
    //解绑
    doLeaveUnused(id) {
      this.osg.confirm('是否确认解绑？', () => {
        this.osg.ajax('basic/winnerlook/leaveUnused.do', { id }, () => {
          this.osg.toast('解绑成功');
          this.getData();
        });
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    },
    renderTitle() {
      let title = '';
      switch (this.useType) {
        case '1':
          title = '用户';
          break;
        case '5':
          title = '服务商';
          break;
      }
      return title;
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.useType = this.$route.query.useType;
      this.doInit();
      this.osg.getFields('winnerLook', () => {
        if (this.useType == '5') {
          this.extFields = this.extFields
            .filter(
              item =>
                item.name != 'orgIds' &&
                item.name != 'orgName' &&
                item.name != 'field1' &&
                item.name != 'field2'
            )
            .sort((q, n) => q.order - n.order);
        }
        this.$nextTick(() => {
          this.osg.listRefresh();
          this.osg.getFpi();
          this.getData();
          this.getOrg();
        });
      });
    }
  }
};
</script>
<style scoped>
/**/
.content-table >>> .el-cascader.el-cascader--small {
  pointer-events: none;
}
.content-table >>> .el-cascader .el-input .el-input__inner {
  border: 0;
}
.content-table >>> .el-input__suffix {
  right: 5px;
  transition: all 0.3s;
  display: none;
}
.content-table >>> .el-input__inner {
  background: transparent;
}
.cascaderwinnerlooks >>> input {
  width: 240px;
}
</style>
